import React from "react";
import MainTemplate from "../components/template/MainTemplate";
import PBLWhisperPopupContainer from "../containers/PBLWhisperPopupContainer";

const PBLWhisperPage = ({ browserType, cookies, routeProps }) => {
    return (
        <MainTemplate>
            <PBLWhisperPopupContainer
                browserType={browserType}
                routeProps={routeProps}
                cookies={cookies}
            />
        </MainTemplate>
    );
};

export default PBLWhisperPage;